import { Scale } from "../components/likert";
import { Customizations, FollowUpLowQuestionOption } from "./survey_question_likert";

export interface LikertCustomizationsNormalized {
  label: string; // customizations.prompt
  description?: string; // customizations.description

  followUpLowDescriptionLabel?: string; // customizations.followUpLowDescription
  followUpLowScore?: boolean; // customizations.followUpLowScore
  followUpLowQuestion?: {
    type: string;
    options: FollowUpLowQuestionOption[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [propName: string]: any;
  };
  followUpLowScoreThreshold?: number; // customizations.lowScoreThreshold
  followUpLowPrompt?: string; // customizations.followUpLowPrompt

  followUpHighScore?: boolean; // customizations.followUpHighScore
  followUpHighScoreThreshold?: number; // customizations.highScoreThreshold
  followUpHighPrompt?: string; // customizations.followUpHighPrompt

  max: Scale; // customizations.max
  maxLabel?: string; // customizations.maxLabel
  min: Scale; // customizations.min
  minLabel?: string; // customizations.minLabel

  displayValues?: string[] | number[]; // customizations.displayValues

  optional: boolean; // customizations.optional
  followUpLowScoreIsOptional: boolean;
  followUpHighScoreIsOptional: boolean;
}

export const useNormalizeSurveyQuestionLikertCustomizations = (
  customizations: Customizations
): LikertCustomizationsNormalized => {
  customizations.followUpLowScore = customizations.followUpLowScore || customizations.followUpScore;
  customizations.followUpLowPrompt =
    customizations.followUpLowPrompt || customizations.followUpPrompt;

  // Deconstruct the customizations object
  const label = customizations.prompt;
  const description = customizations.description;

  const followUpLowDescriptionLabel = customizations.followUpLowDescription;
  const followUpLowScore = customizations.followUpLowScore;
  const followUpLowQuestion = customizations.followUpLowQuestion; // a non-open-response follow up (in practice, a multi-select question)
  const followUpLowScoreThreshold = customizations.lowScoreThreshold ?? 4; // mirrors default set in likert_question_wrapper
  const followUpLowPrompt = customizations.followUpLowPrompt;
  // Based on hard-coded values in legacy component app/javascript/components/surveys/questions/components/likert.tsx
  const followUpLowScoreIsOptional = followUpLowQuestion ? !!followUpLowQuestion.optional : true;

  const followUpHighScore = customizations.followUpHighScore;
  const followUpHighScoreThreshold = customizations.highScoreThreshold ?? 5; // mirrors default set in likert_question_wrapper
  const followUpHighPrompt = customizations.followUpHighPrompt;
  // Based on hard-coded values in legacy component app/javascript/components/surveys/questions/components/likert.tsx
  const followUpHighScoreIsOptional = false;

  const max = customizations.max ?? 7;
  const maxLabel = customizations.maxLabel;
  const min = customizations.min ?? 1;
  const minLabel = customizations.minLabel;

  const displayValues = customizations.displayValues;

  const optional = typeof customizations.optional === "undefined" ? false : customizations.optional;

  return {
    label,
    description,

    followUpLowDescriptionLabel,
    followUpLowScore,
    followUpLowQuestion,
    followUpLowScoreThreshold,
    followUpLowPrompt,

    followUpHighScore,
    followUpHighScoreThreshold,
    followUpHighPrompt,

    max,
    maxLabel,
    min,
    minLabel,

    displayValues,

    optional,
    followUpLowScoreIsOptional,
    followUpHighScoreIsOptional,
  };
};
